var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.settings.message.general") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("Label", {
                    attrs: {
                      text: _vm.$t("apps.settings.message.roletitle") + " *"
                    }
                  }),
                  _vm._v(" "),
                  _c("BaseInput", {
                    attrs: {
                      classNames: [{ "is-invalid": _vm.$v.input.title.$error }],
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.$v.input.title.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.input.title, "$model", $$v)
                      },
                      expression: "$v.input.title.$model"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.settings.message.setpermissions") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-12" } },
                [
                  _c("BaseRolePermission", {
                    attrs: {
                      masterData: _vm.appRolePermissions,
                      data: _vm.input.permissions
                    },
                    on: {
                      "update:data": function($event) {
                        return _vm.$set(_vm.input, "permissions", $event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("BaseFormAction", {
        attrs: {
          textCancel: _vm.$t("button.cancel"),
          textSubmit: _vm.$t("button.save"),
          isSubmitted: _vm.isSubmitted
        },
        on: { onCancel: _vm.handleCancel, onSubmit: _vm.handleSubmit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d340c6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d340c6e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/RolePermissionForm.vue
// module id = null
// module chunks = 